import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

export interface BuildingUtilizationFilterDatamodel {
  visible: boolean;
  onHide: () => any;
  startDateDefaultValue: Date;
  endDateDefaultValue: Date;
  startTimeDefaultValue: string;
  endTimeDefaultValue: string;
  onFinish: (
    startDate: Date,
    endDate: Date,
    startTime: string,
    endTime: string,
  ) => any;
  title: string;
}

export const BuildingUtilizationFilter: React.FC<
  BuildingUtilizationFilterDatamodel
> = ({
  visible,
  onHide,
  startDateDefaultValue,
  endDateDefaultValue,
  startTimeDefaultValue,
  endTimeDefaultValue,
  onFinish,
  title,
}) => {
  const [startDate, setStartDate] = useState<Date>(startDateDefaultValue);
  const [endDate, setEndDate] = useState<Date>(endDateDefaultValue);
  const [startTime, setStartTime] = useState<string>(startTimeDefaultValue);
  const [endTime, setEndTime] = useState<string>(endTimeDefaultValue);

  // Generate hour options (00:00 to 23:00)
  const timeOptions = Array.from({ length: 24 }, (_, i) => ({
    label: `${i.toString().padStart(2, '0')}:00`,
    value: `${i.toString().padStart(2, '0')}:00`,
  }));

  // Update local state when default values change
  useEffect(() => {
    setStartDate(startDateDefaultValue);
    setEndDate(endDateDefaultValue);
    setStartTime(startTimeDefaultValue);
    setEndTime(endTimeDefaultValue);
  }, [
    startDateDefaultValue,
    endDateDefaultValue,
    startTimeDefaultValue,
    endTimeDefaultValue,
  ]);

  const handleApply = () => {
    onFinish(startDate, endDate, startTime, endTime);
    onHide();
  };

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: '500px' }}
      onHide={() => onHide()}
      modal
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* Date Range Section */}
        <div style={{ display: 'flex', gap: '16px' }}>
          <div style={{ flex: 1 }}>
            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              תאריך התחלה:
            </label>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              inputStyle={{ textAlign: 'right' }}
              style={{
                direction: 'ltr',
                width: '100%',
                textAlign: 'right',
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              תאריך סיום:
            </label>
            <Calendar
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              inputStyle={{ textAlign: 'right' }}
              style={{
                direction: 'ltr',
                width: '100%',
                textAlign: 'right',
              }}
            />
          </div>
        </div>

        {/* Time Range Section */}
        <div style={{ display: 'flex', gap: '16px' }}>
          <div style={{ flex: 1 }}>
            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              שעת התחלה:
            </label>
            <Dropdown
              value={startTime}
              options={timeOptions}
              onChange={(e) => setStartTime(e.value)}
              style={{ width: '100%' }}
              placeholder="בחר שעה"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              שעת סיום:
            </label>
            <Dropdown
              value={endTime}
              options={timeOptions}
              onChange={(e) => setEndTime(e.value)}
              style={{ width: '100%' }}
              placeholder="בחר שעה"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '16px',
          }}
        >
          <Button label="ביטול" outlined onClick={() => onHide()} />
          <Button label="החל" onClick={handleApply} />
        </div>
      </div>
    </Dialog>
  );
};
